<template>
    <div class="cardio">
        <van-row class="top">
            <van-col span="24" class="s1">基本信息</van-col>
            <van-col span="24" class="s2">
                <span>姓名：{{row.nickname}}</span>
                <span>年龄：{{row.ownerAge}}</span>
                <span>性别：{{row.ownerGender}}</span>
            </van-col>
            <van-col span="24" class="s2">测量时间：{{row.create_time}}</van-col>

            <van-col span="24">
                <div id="main"></div>
            </van-col>
            <van-col span="24" class="s1">解读结果</van-col>
            <van-col span="24" class="s-diags">{{row.diags}}</van-col>
            <van-col span="12" class="s3">
                <span>平均心率：{{row.avgHr}}</span>
            </van-col>
            <van-col span="12" class="s3">
                <span>Q-t间期：{{row.avgQt}}</span>
            </van-col>
            <van-col span="12" class="s3">
                <span>Q-Qrs宽度：{{row.avgQrs}}</span>
            </van-col>
            <van-col span="12" class="s3">
                <span>Q-QTc值：{{row.avgQtc}}</span>
            </van-col>
            <van-col span="24" class="s3">
                <span>PR期间：{{row.prIntervals}}</span>
            </van-col>
            <van-col span="24" class="s4">
                <span>本结论仅做为临床建议,不做为临床诊断依据,其他情况 请结合临床.</span>
            </van-col>
        </van-row>

    </div>
</template>
<script>
    import Vue from 'vue';
    import { Col, Row } from 'vant';

    Vue.use(Col).use(Row);
    import {cardioDetail} from '../../api/cardio';

    let echarts = require('echarts/lib/echarts');
    // 引入柱状图组件
    require('echarts/lib/chart/line');

    // 引入提示框和title组件
    require('echarts/lib/component/title');
    require('echarts/lib/component/dataZoom');
    require('echarts/lib/component/tooltip');

    export default {
        name: "newsDetail",
        data() {
            return {
                row: {}
            };
        },
        mounted() {
            let _this = this;
            cardioDetail({
                imei: this.$route.query.imei,
                id: this.$route.query.id
            }).then(res => {
                    if (res.code === 1) {
                        _this.row = res.content;
                        this.drawLine(res.content.path);
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                });
        },
        methods: {
            drawLine(value){
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('main'))
                // 绘制图表
                myChart.setOption({
                    title: {
                        show: false
                    },
                    grid: {
                        top: 30,
                        bottom: 50,
                        left: '1%',
                        right: '1%'
                    },
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: value.split(','),
                        show: false
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: '#a9a8ae',  // 更改坐标轴文字颜色
                            }
                        },
                        show: false,
                        axisLine:{
                            lineStyle: {
                                color:'#FFF'
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#E8EDE9',
                                type: 'solid'
                            }

                        }
                    },
                    dataZoom: [
                        {
                            type: 'slider',//图表下方的伸缩条
                            show : true, //是否显示
                            realtime : false, //拖动时，是否实时更新系列的视图
                            start : 0, //伸缩条开始位置（1-100），可以随时更改
                            end : 15, //伸缩条结束位置（1-100），可以随时更改
                        }
                    ],
                    series: [{
                        name:'测量值',
                        data: value.split(','),
                        type: 'line',
                        itemStyle: {
                            color: '#ff0000',
                            borderColor: '#ff0000'
                        },
                        connectNulls:true
                    }]
                });
            }
        }
    };

</script>
<style lang="scss" scoped>
    .cardio {
        .top {
            font-size: 12px;
            padding: 10px;
            line-height: 22px;
            .s1 {
                font-size: 13px;
                padding-bottom: 10px;
            }
            .s2 {
                color: #666;
                span {
                    margin-right: 15px;
                    display: inline-block;
                }
            }
        }
        #main {
            width: 100%;
            height: 400px;
        }
        .s-diags {
            height: 100px;
            line-height: 100px;
            font-size: 14px;
            background: #32A772;
            border-radius: 5px;
            text-align: center;
            color: #fff;
        }
        .s3 {
            padding-top: 10px;
            font-size: 13px;
        }
        .s4 {
            padding-top: 10px;
            font-size: 10px;
            color: #acacac;
        }
    }
</style>